import React, { useRef, useState } from "react";

const HeroBanner: React.FC = () => {
  const videoRef = useRef<HTMLVideoElement | null>(null);

  const [muted, setMuted] = useState(true);

  const toggleSound = () => {
    if (videoRef.current) {
      videoRef.current.muted = !muted;
      setMuted(!muted);
    }
  };
  return (
    <section className="hero">
      <div className="hero-border-banner">
        <div className="hero-container">
          {/* Desktop Video */}
          <video
            className="hero-video"
            autoPlay
            muted={muted}
            loop
            playsInline
            ref={videoRef}
          >
            <source
              src={
                window.innerWidth <= 768 ? "/HOB_Intro_m.mp4" : "/HOB_Intro.mp4"
              }
              type="video/mp4"
            />
          </video>
          <button className="sound-btn" onClick={toggleSound}>
            {muted ? "🔇 Sound Off" : "🔊 Sound On"}
          </button>
          <div className="overlay"></div>
        </div>
        <div className="hero-title">
          <h1>Where the City Finds Its Table</h1>
        </div>
      </div>
    </section>
  );
};

export default HeroBanner;
